<!-- HEADER -->
<header id="shell-header" *ngIf="showHeader">
  <div class="header-inner">
    <span class="page-title">{{ titleService.title() }}</span>
  </div>
</header>

<!-- CONTENIDO PRINCIPAL -->
<main id="shell-main">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>
